module.exports = __webpack_public_path__ + "img/transform_perspective_matte.a1998e1c.png";